export enum LandingRecords {
  ASSIGNED = 'ASSIGNED',
  NOT_ASSIGNED = 'NOT_ASSIGNED',
  ASSIGNED_TO_ME = 'ASSIGNED_TO_ME',
  ASSIGNED_OTHERS = 'ASSIGNED_OTHERS'
}
